import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import { searchFail, cruiseSearchRequest, searchSuccess } from '../../slices/tripSearch';

const queryString = require('query-string');

function* searchWorker() {
  try {
    const searchObj = yield select((state) => state.tripSearch.searchObj.cruise);
    // format searchObj
    const {
      value: flightOriginGeoIndex,
      featureClass: flightOriginFeatureClass,
    } = searchObj.filters.origin || {};
    const { from: cruiseLengthFrom, to: cruiseLengthTo } = searchObj.duration;
    const {
      fromDate, toDate, page, pageSize, sortBy, sortDirection, doReturnOnlyAddedUpdatedItineraries,
    } = searchObj;
    const {
      discounts, portOfDepartureOption, cabinType,
    } = searchObj.filters;
    const cruiseLineIds = searchObj.filters.cruiseLines.map((c) => Number.parseInt(c.value, 10));
    const cruiseShipIds = searchObj.filters.cruiseShips.map((c) => Number.parseInt(c.value, 10));
    const cityIds = searchObj.filters.cityIds
      && searchObj.filters.cityIds.map((c) => Number.parseInt(c.value, 10));

    const portOfDeparturePreference = {
      portOfDepartureOption,
      flightOriginGeoIndex: Number.parseInt(flightOriginGeoIndex || 0, 10),
      flightOriginFeatureClass,
      cityIds,
    };

    const request = {
      cruiseLengthFrom,
      cruiseLengthTo,
      fromDate,
      toDate,
      cruiseLineIds,
      cruiseShipIds,
      portOfDepartureOption,
      cabinType,
      discounts,
      page,
      pageSize,
      sortBy,
      sortDirection,
      doReturnOnlyAddedUpdatedItineraries,
    };

    if (searchObj.locations) {
      searchObj.locations.forEach((item, index) => {
        request[`locationIds[${index}].id`] = Number.parseInt(item.value, 10);
        request[`locationIds[${index}].type`] = Number.parseInt(item.locationType, 10);
      });
    }

    const url = `/cruises/search?${queryString.stringify(request)}`;
    const config = {
      method: 'post',
      url,
      data: JSON.stringify(portOfDeparturePreference),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(axios, config);
    if (response.data) {
      yield put(searchSuccess(response.data));
    } else throw new Error();
  } catch (error) {
    console.error(error);
    yield put(searchFail(error));
  }
}

function* searchWatcher() {
  yield takeLatest(cruiseSearchRequest.toString(), searchWorker);
}

export default searchWatcher;
